import { defineMessages } from 'react-intl';

export default defineMessages({
  caloriesDisclaimer: {
    id: 'ordering.productDetailsHeader.caloriesDisclaimer',
    defaultMessage:
      'Nutrition information is based on standard recipes and does not reflect customizations',
    description: 'Disclaimer for calories tool tip',
  },
  caloriesDisclaimerAriaLabel: {
    id: 'ordering.productDetailsHeader.caloriesDisclaimerAriaLabel',
    defaultMessage: 'See calories disclaimer',
    description: 'Aria label for calories disclaimer tooltip button',
  },
});
